const summaryAndCheckout = document.querySelector("#summaryAndCheckout");
const divCheckoutOptionsBtn = document.querySelector("#div_checkoutoptionsbtn");
if (
  summaryAndCheckout instanceof HTMLElement &&
  divCheckoutOptionsBtn instanceof HTMLElement
) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          divCheckoutOptionsBtn.classList.add("d-none");
        } else {
          divCheckoutOptionsBtn.classList.remove("d-none");
        }
      });
    },
    {
      rootMargin: "0px 0px -200px 0px",
      threshold: 0,
    },
  );
  observer.observe(summaryAndCheckout);
}
